import { registerPlugin } from '@capacitor/core';

interface XimiAuthSessionPlugin {
    /** Resolves `{ url }` with the callback URL, nothing when the user cancels. */
    start(options: { url: string; callbackScheme: string }): Promise<{ url: string } | undefined>;
}

/** iOS only: ASWebAuthenticationSession, app-local plugin (ios/App/App/XimiAuthSessionPlugin.swift). */
export const XimiAuthSession = registerPlugin<XimiAuthSessionPlugin>('XimiAuthSession');
